export default __webpack_public_path__ + "static/media/BornaB.899e162a.png";